const CONFIG = {
    env: "prod",
    author: "MEDISOURCE",
    API: "https://hrapi.medisource.com",
    JWT: {
        secret: "4a478258bd8e11f4046d6fe49471401893d69469"
    },
    gcloundlink: "https://medisource.storage.googleapis.com",
    clientsApi : {
    	healthcare  : "https://qado.medisource.com:8081",
    	woundtrack  : "https://qaapi.woundtrack.com"
    }
    
};

export default CONFIG